import { DataVoyagerWidgetData, WidgetType } from '@/models/PanelWidgets';

import { v4 as uuidV4 } from 'uuid';

export type DataVoyagerWidgetDataFromApi = {
  id: string;
  logs: string;
};

export const dataVoyagerWidgetFactory = ({
  id,
  logs,
}: {
  id?: string;
  logs?: string;
} = {}): DataVoyagerWidgetData => {
  return {
    id: id ?? uuidV4(),
    type: WidgetType.DATA_VOYAGER,
    logs: logs ?? '',
  };
};

export function getDataVoyagerWidgetDataFromApi(
  args: DataVoyagerWidgetDataFromApi,
): DataVoyagerWidgetData {
  return dataVoyagerWidgetFactory(args);
}
